import React from "react";
import { Container, Row, Col } from "shards-react";
import PolicyVehicles from "../components/contracts/policies/vehicles";


import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';

function handleClick(event) {
  event.preventDefault();
}

const PolicyVehiclesTable = () => (
  <Container fluid className="main-content-container px-4">
  	<Row>
	  	<Col className="p-2">
  	   	<Breadcrumbs separator=">" aria-label="breadcrumb">
	      <Link href="/contracts" color="textPrimary" variant="button" >Contratos</Link>
	      <Link href="/contracts" color="textPrimary" variant="button">Política de flota</Link>
	      <Typography color="textPrimary" variant="button">Vehículos</Typography>
	    </Breadcrumbs>
		</Col>
	</Row>
	  <Row>
      <Col className="p-2">
		    <PolicyVehicles /> 
      </Col>
    </Row>
   </Container>
);

export default PolicyVehiclesTable;
